/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Image, Text, VStack, SimpleGrid, useToast, HStack, Grid } from '@chakra-ui/react';
import { useTheme } from '../../contexts/ThemeProvider';
import { BannerCarousel } from '../../components/molecules/Carousel';
import { ReactNode, useEffect } from 'react';
import { IModules } from '@partiu/api/types';
import React from 'react';

import pako from 'pako';
import { useNavigate } from 'react-router-dom';
import { MainTemplate } from '../../templates/MainTemplate';
import { useProfile } from '@partiu/ui/contexts/ProfileProvider';
import { APP_EVENTS, spawnAppEvent } from '@partiu/ui/mobileEvents';

const Label = ({ children }: { children: ReactNode }) => {
  return (
    <Text fontFamily={'Glory'} fontWeight={500} fontSize={20} color="black">
      {children}
    </Text>
  );
};

const Benefits = ({
  maskColor,
  title,
  benefitTitle,
  icon,
  url,
  is_external,
  data,
  onNavigateModule,
  isNative,
}: IModules) => {
  return (
    <Box
      sx={{
        '&:hover': {
          textDecoration: 'none',
        },
      }}
      cursor={'pointer'}
      onClick={() => onNavigateModule(url, is_external, data)}
    >
      <VStack width="100%" marginBottom={'auto'} align={'center'} justifyContent={'center'}>
        <Box
          width="100%"
          height={'100%'}
          borderRadius={{
            base: isNative ? '12px' : '24px',
            sm: isNative ? '12px' : '24px',
            md: isNative ? '12px' : '12px',
            lg: '24px',
          }}
          bg="white"
        >
          <Box position={'relative'} width="100%" height={'100%'}>
            {benefitTitle !== 'Streaming' && (
              <Box
                position={'absolute'}
                mixBlendMode={'color'}
                width="100%"
                height={'100%'}
                borderRadius={{
                  base: isNative ? '12px' : '24px',
                  sm: isNative ? '12px' : '24px',
                  md: isNative ? '12px' : '12px',
                  lg: '24px',
                }}
                bg={maskColor}
              />
            )}
            <Image
              margin={'auto'}
              padding={{
                base: isNative ? '12px' : '20px',
                sm: '20px',
                md: '20px',
                lg: '20px',
              }}
              minH={{
                base: isNative ? '57px' : '100px',
                sm: '115px',
                md: '125px',
                lg: '135px',
              }}
              width={isNative ? '100%' : '100%'}
              height={'100%'}
              src={icon}
            />
          </Box>
        </Box>
        <Text
          color="#747474"
          fontWeight={'500'}
          fontSize={isNative ? '0.8rem' : '18px'}
          fontFamily={'Glory'}
          whiteSpace={'normal'}
          textAlign={'center'}
        >
          {title}
        </Text>
      </VStack>
    </Box>
  );
};

export function BenefitsPage() {
  const { banners, isApp, benefits, isNative, colors, openModalLogin } = useTheme();

  const [isIframeActive, setIframeActive] = React.useState(false);

  const { profile } = useProfile();

  const navigate = useNavigate();
  const [benefitsFormated, setBenefitsFormated] = React.useState<any>();

  const toast = useToast();
  const [url, setUrl] = React.useState<any>();

  useEffect(() => {
    if (benefits) {
      const sortedBenefits = [...benefits].sort((a, b) => {
        if (a.title === 'Economizar') return -1;
        if (b.title === 'Economizar') return 1;
        if (a.title === 'Benefícios Para Ler') return -1;
        if (b.title === 'Benefícios Para Ler') return 1;
        if (a.title === 'Benefícios') return -1;
        if (b.title === 'Benefícios') return 1;

        return 0;
      });
      setBenefitsFormated(sortedBenefits);
    }
  }, [benefits]);

  const onNavigateModule = (url: string, isExternal: boolean, data: any) => {
    if (!profile) {
      openModalLogin();
      return;
    }

    if (data) {
      data.token = localStorage.getItem('token');
      data.tokenExpirationDate = localStorage.getItem('tokenExpirationDate');

      const jsonData = JSON.stringify(data);

      const compressedData = pako.deflate(jsonData);
      const base64Data = btoa(String.fromCharCode(...compressedData));

      const formattedUrl = url.endsWith('/') ? url.slice(0, -1) : url;

      const urlFormated = `${formattedUrl}/acervo?isNative=true&data=${encodeURIComponent(base64Data)}`;

      setUrl(urlFormated);
    } else if (isExternal) {
      if (isApp) {
        spawnAppEvent(APP_EVENTS.OPEN_LINK, url);
      } else {
        window.open(url, '_blank');
      }
    } else {
      if (url.includes('http')) {
        navigate(url);
      } else {
        if (!isNative) {
          navigate(`/vantagens`, {
            state: { action: url },
          });
        } else {
          toast({
            title: 'Oops',
            description: 'Essa ação irá filtrar as vantagens no seu App',
            status: 'error',
          });
        }
      }
    }
  };

  if (url) {
    return (
      <MainTemplate
        isIframeActive={isIframeActive}
        isIFrame
        isNative={isNative}
        hideBottomMenu={isNative}
        goBack={() => setUrl(undefined)}
      >
        <iframe
          src={url}
          style={{
            zIndex: 150,
            width: '100%',
            height: isNative ? '90vh' : '86vh',
            border: 'none',
            touchAction: 'auto',
          }}
          onMouseEnter={() => setIframeActive(true)}
          onMouseLeave={() => setIframeActive(false)}
          onTouchStart={() => setIframeActive(true)}
          allow="fullscreen; autoplay; clipboard-write"
        />
      </MainTemplate>
    );
  }

  return (
    <MainTemplate hideBottomMenu={isNative} hideTopMenu={isNative}>
      <VStack
        align={'self-start'}
        width={'100%'}
        marginBottom={isNative ? '0px' : '100px'}
        paddingTop={'10px'}
        spacing={4}
      >
        <BannerCarousel isNative={isNative} banners={banners} />

        <Grid
          padding={{
            base: isNative ? '10px' : '20px',
          }}
          width={'100%'}
          templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(2, 1fr)' }}
          gap={isNative ? 2 : 4}
        >
          {Array.isArray(benefitsFormated) &&
            benefitsFormated.length > 0 &&
            benefitsFormated?.map((benefit) => (
              <VStack key={benefit?.id} width={'100%'} align={'self-start'}>
                <Label>{benefit.title}</Label>
                <Grid
                  width={'100%'}
                  templateColumns={{
                    base: 'repeat(3, 1fr)',
                    sm: 'repeat(3, 1fr)',
                    md: 'repeat(3, 1fr)',
                    lg: 'repeat(4, 1fr)',
                  }}
                  gap={isNative ? 2 : 6}
                >
                  {benefit.modules?.map((a: any) => (
                    <Benefits
                      {...a}
                      isNative={isNative}
                      benefitTitle={benefit.title}
                      maskColor={colors.primaryColor}
                      onNavigateModule={onNavigateModule}
                    />
                  ))}
                </Grid>
              </VStack>
            ))}
        </Grid>
        {Array.isArray(benefitsFormated) && benefitsFormated.length === 0 && (
          <VStack width={'100%'} margin={'auto'} align={'center'} justifyContent={'center'}>
            <Text color="#747474" fontWeight={'500'} fontSize={'18px'} fontFamily={'Glory'} textAlign={'center'}>
              Não há benefícios disponíveis no momento
            </Text>
          </VStack>
        )}
      </VStack>
    </MainTemplate>
  );
}
